// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27ceE","rootNoMargin":"styles_rootNoMargin__3HQ65"};